import { render, staticRenderFns } from "./ViewInstitute.vue?vue&type=template&id=22136515"
import script from "./ViewInstitute.vue?vue&type=script&lang=js"
export * from "./ViewInstitute.vue?vue&type=script&lang=js"
import style0 from "./ViewInstitute.vue?vue&type=style&index=0&id=22136515&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports